module.exports = __webpack_public_path__ + "static/media/no_data_1.84c83d4c.png";